var map = {
	"./Abbreviations.png": 76339,
	"./Abbreviations2.png": 27529,
	"./Anagrams.png": 17864,
	"./Bingo.png": 51397,
	"./CareerPath.png": 1917,
	"./CategoriesGame.png": 88448,
	"./CategoryGame.png": 62152,
	"./DriverSeason.png": 87051,
	"./DriverStats.png": 71567,
	"./DriversConnection.png": 59177,
	"./DriversLink.png": 49669,
	"./F1Grid.png": 52505,
	"./F1Impostors.png": 28839,
	"./F1Wordle.png": 70772,
	"./FormulaCarLoading.png": 3936,
	"./GuessDriver.png": 38285,
	"./GuessTeam.png": 5564,
	"./HigherLower.png": 63004,
	"./LightsOut.png": 4213,
	"./Memory.png": 70875,
	"./OrderDriversGame.png": 4597,
	"./OverCutDraft.png": 22889,
	"./OverCutRacing.svg": 51782,
	"./RaceGame.png": 15859,
	"./RacingHelmet.png": 95019,
	"./Rondo.png": 91430,
	"./TeamHistory.png": 73489,
	"./TeamNationality.png": 39095,
	"./TeamNationality2.png": 64645,
	"./ThirtySeconds.png": 52179,
	"./ThirtySeconds2.png": 86985,
	"./Timeline.png": 34999,
	"./Timeline2.png": 50853,
	"./Tower.png": 94999,
	"./Tower2.png": 29861,
	"./TwoTeams.png": 26934,
	"./WhoAmI.png": 44857,
	"./WhoAmI2.png": 75407,
	"./bingo.png": 23845,
	"./crossword.png": 60540,
	"./gameCategory.png": 47624,
	"./raceGame.png": 61427,
	"./searchGame.png": 54100,
	"./tictactoe.png": 26456,
	"./top10.png": 83206,
	"./top10quali.png": 30002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2652;